import { css } from 'styled-components';
import { generateClassPropertyValue } from './functions';

const marginValues = [10, 15, 20, 30]; // add values as needed

const getMarginsCss = () => {
  let styles = '';

  marginValues.forEach((margin) => {
    styles += generateClassPropertyValue('mt', 'margin-top', margin);
    styles += generateClassPropertyValue('mb', 'margin-bottom', margin);
    styles += generateClassPropertyValue('ml', 'margin-left', margin);
    styles += generateClassPropertyValue('mr', 'margin-right', margin);
  });

  return css`
    ${styles}
  `;
};

const margins = getMarginsCss();

export default margins;
